import React, {Component} from 'react';
import axios from 'axios';
import {Icon, Card, CardTitle, CardText, CardActions, Button, Textfield } from 'react-mdl';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';

class Send extends Component {
  componentDidMount() {
    axios.get('https://ibankcoin.com/api/post?blogId=' + this.props.location.query.blogid + '&postId=' + this.props.location.query.postid) // 60461
      .then(res => {
        console.log('fetch post from api res:', res);
        
        let post = Object.assign({}, res.data, {fpPicMed: res.data.fpPicMed.replace('http://', 'https://')});
        
        this.setState({
          postLoaded: true,
          post: post
        });
      });
  }
  constructor(props) {
    super(props);
    this.state = Object.assign({}, props, {
      toAddress: "",
      postLoaded: false,
      note: ""
    });
    autoBind(this);
  }
  handleSubmit(e) {
    e.preventDefault();
    let msg = {
      html: '<p style="margin-top: 0px;"><a href="' + this.state.post.postPermalink + '">' + this.state.post.postTitle + '</a></p><p><strong>Note from sender:</strong><br>' + this.state.note.replace(/(<([^>]+)>)/ig,"") + '</p><p style="font-size: 10px; color: #aaa; margin-top: 20px;">You are receiving this email because somebody on iBankCoin wanted to pass this article along to you. If you feel you have received this message in error, or have any questions, please reply directly to this email for prompt assistance.</p>',
      subject: 'Somebody shared a link with you on iBankCoin',
      from_email: 'customerservices@ibankcoin.com',
      from_name: 'iBankCoin',
      to: [{
        email: this.state.toAddress,
        name: this.state.toAddress,
        type: 'to'
      }]
    };

    // ajax post msg to SLS
    axios.post('https://yl026sjka2.execute-api.us-east-1.amazonaws.com/dev/util/email', msg)
      .then(function(response) {
        // console.log('response:', response);
        // route change to "thanks" page
        browserHistory.push('/success');
      })
      .catch(function(error) {
        // console.log('error:', error);
        // show a snackbar saying there was a problem?
      });
  }
  handleChangeNote(e) {
    // console.log('called handleChangeNote()', e.target.value, this.state);
    let note = e.target.value;
    if(note.length > 10000) return;
    
    this.setState({
      note: note
    });
  }
  handleChangeToAddress(e) {
    // console.log('called handleChangeToAddress()', e.target.value, this.state);
  
    this.setState({
      toAddress: e.target.value.replace(' ', '')
    });
  }
  render() {
    // console.log('Post render() this.props:', this.props);
    // console.log('Post render() this.state:', this.state);

    // don't render until post has been fetched
    if (!this.state.postLoaded || !this.state.post) return null;

    return (
      <div className="main">
        <div className="content-header">
          <Icon name="exit_to_app" style={{fontSize: '40px'}} />
          <h3>Send Post to a Friend</h3>
        </div>
        <Card shadow={0} style={{margin: 'auto'}}>
          <CardText>
            <img src={this.state.post.fpPicMed} style={{padding: '0 0 20px 0', maxWidth: '100%'}} />
            <h2 className="post-box-title">{this.state.post.postTitle}</h2>
          </CardText>
          <CardText>
            <Textfield
              onChange={this.handleChangeToAddress}
              pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              label="TO address"
              floatingLabel
              required
              value={this.state.toAddress}
              type="email"
            />
            <Textfield
              onChange={this.handleChangeNote}
              label="Note (optional)"
              floatingLabel
            />
          </CardText>
          <CardActions border style={{textAlign: 'right', padding: '20px'}}>
            <Button onClick={this.handleSubmit} raised colored>Send</Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

export default Send;



/** WEBPACK FOOTER **
 ** ./src/components/Send.js
 **/